import { render, staticRenderFns } from "./DashboardTree.vue?vue&type=template&id=c72376f0&scoped=true"
import script from "./DashboardTree.vue?vue&type=script&lang=js"
export * from "./DashboardTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72376f0",
  null
  
)

export default component.exports